import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: resolve => require(["../views/home/Home.vue"], resolve)
  },
  {
    path: "/nav",
    component: resolve => require(["../views/nav/Nav.vue"], resolve),
    meta: {
      title: "导航 - 穆雄雄",
      description:
        "穆雄雄的站点导航：区域慢病管理、数智长护监管、智慧电梯追溯三个方案演示，自研小程序，CSDN 与公众号，GitHub 与 Gitee 开源仓库，以及联系方式。"
    }
  },
  {
    path: "/works",
    component: resolve => require(["../views/works/Works.vue"], resolve),
    meta: {
      title: "产品与项目 - 穆雄雄",
      description:
        "穆雄雄做过的产品与项目：区域慢病管理平台、数智长护整体监管、智慧电梯追溯维保三个可在线演示的行业方案，以及小鱼早晚安、雄雄的工具箱等自研小程序。"
    }
  },
  {
    path: "/story",
    component: resolve => require(["../views/story/Story.vue"], resolve),
    meta: {
      title: "我的故事 - 穆雄雄",
      description:
        "穆雄雄的故事：十六岁靠一颗色子选了济南，兜里两块钱下火车，从酒店前台收银到半工半读学编程，教了五年计算机，现在是技术经理。"
    }
  },
  {
    path: "/articles/:articleId",
    component: resolve => require(["../views/article/Article.vue"], resolve)
  },
  {
    path: "/about",
    component: resolve => require(["../views/about/About.vue"], resolve),
    meta: {
      title: "关于我 - 穆雄雄",
      description:
        "穆雄雄，山西吕梁人，现在济南。从酒店前台自学编程入行，教了五年计算机，现在做医疗与医保信息化。CSDN 十年 1345 篇原创，公众号雄雄的小课堂与长护视点。"
    }
  },
  {
    path: "/message",
    component: resolve => require(["../views/message/Message.vue"], resolve),
    meta: {
      title: "留言板 - 穆雄雄",
      description: "给穆雄雄留言。"
    }
  },
  {
    path: "/user",
    component: resolve => require(["../views/user/User.vue"], resolve),
    meta: {
      title: "个人中心 - 穆雄雄"
    }
  },
  {
    path: "/callback/qq",
    component: resolve => require(["../components/OauthLogin.vue"], resolve)
  },
  {
    path: "/callback/gitee",
    component: resolve => require(["../components/OauthLogin.vue"], resolve)
  },
  {
    path: "/callback/weibo",
    component: resolve => require(["../components/OauthLogin.vue"], resolve)
  },
  {
    // 兜底：相册这类已下线的地址和任何拼错的路径都回首页，不要留白屏
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  }
});

export default router;
